import { MembershipsV1PlanId, SettingsV1TenantType } from '@sdk/Api'

export const membershipPlanGroup = {
	[SettingsV1TenantType.TENANT_TYPE_ECOMMERCE]: [
		MembershipsV1PlanId.PLAN_ID_FREEMIUM,
		MembershipsV1PlanId.PLAN_ID_STARTER,
		MembershipsV1PlanId.PLAN_ID_BUSINESS,
		MembershipsV1PlanId.PLAN_ID_ENTERPRISE,
		MembershipsV1PlanId.PLAN_ID_ENTERPRISE_PLUS,
	],
	[SettingsV1TenantType.TENANT_TYPE_NETWORK]: [
		MembershipsV1PlanId.PLAN_ID_FREEMIUM,
		MembershipsV1PlanId.PLAN_ID_ENTERPRISE,
		MembershipsV1PlanId.PLAN_ID_NETWORK_SEED,
		MembershipsV1PlanId.PLAN_ID_NETWORK_GROWTH,
		MembershipsV1PlanId.PLAN_ID_NETWORK_PLUS,
	],
}
